// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"d9dacdac","160":"581b904e","208":"0134ca38","293":"96d04e6a","453":"a6a97343","516":"10f0582c","519":"d6441f91","917":"b8d0d0ea","946":"ceb14987"}[chunkId] + ".chunk.js";
};